import dayjs from 'dayjs';
import React from 'react';
import Box from '../../components/Box';
import Pie from '../../components/Pie';
import { PieProps } from '../../components/Pie/Pie';
import Typography from '../../components/Typography';
import { translate } from '../../i18n';

interface ACardSummaryProps {
  card: Api.UserACard;
}

const ACardSummary: React.FC<ACardSummaryProps> = ({ card }) => {
  const pointsRemainder = React.useMemo(() => {
    return card.pointsBalance % 10;
  }, [card.pointsBalance]);

  const firstValidCheque = React.useMemo(
    () =>
      card.cheques?.reduce((previous, next) => {
        const previousDate = dayjs(previous.chequeValidTill);
        const nextDate = dayjs(next.chequeValidTill);

        return previousDate < nextDate ? previous : next;
      }),
    [card.cheques],
  );

  return (
    <>
      <Box classNames="ckp-m-acard-box">
        <div className="u-margin-right">
          <Typography variant="h6">{translate('acard.pointsCheques.points.title')}</Typography>
          <Typography>
            {translate('acard.pointsCheques.points.description', {
              points: 10 - pointsRemainder,
            })}
          </Typography>
        </div>

        <Pie
          progress={(pointsRemainder * 10) as PieProps['progress']}
          fill="#E5EFF7"
          stroke="#0064B4"
        />
      </Box>

      {card.cheques && card.cheques.length >= 1 && (
        <Box classNames="ckp-m-acard-box">
          <div className="u-margin-right">
            <Typography variant="h6">{translate('acard.pointsCheques.cheques.title')}</Typography>
            <Typography>
              {translate('acard.pointsCheques.cheques.description', {
                date: dayjs(firstValidCheque!.chequeValidTill).format('DD/MM/YYYY'),
              })}
            </Typography>
          </div>

          <Pie value={card.cheques.length} progress={100} fill="transparent" stroke="#E04E39" />
        </Box>
      )}

      {(!card.cheques || card.cheques.length < 1) && (
        <Box classNames="u-margin-top">
          <Typography classNames="u-text-light">
            {translate('acard.pointsCheques.save.empty')}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ACardSummary;
